import { useState, useCallback } from 'react'

const useSort = ({ defaultOrderBy = 'name' }) => {
  const [orderBy, setOrderBy] = useState(defaultOrderBy)
  const [orderDirection, setOrderDirection] = useState('desc')

  const compare = useCallback((a, b) => {
    if (!a[orderBy] || !b[orderBy]) {
      return 0
    }
    return a[orderBy].toString().localeCompare(b[orderBy], 'en', {numeric: true})
  }, [orderBy])

  const sort = useCallback((items) => {
    if (!items) return []
    return [...items].sort((a, b) => {
      return orderDirection === 'desc' ? compare(b, a) : compare(a, b)
    })
  }, [compare, orderDirection])

  const orderByChange = useCallback((newOrderBy) => {
    if (newOrderBy === orderBy) {
      setOrderDirection(prev => prev === 'desc' ? 'asc' : 'desc')
    } else {
      setOrderBy(newOrderBy)
      setOrderDirection('desc')
    }
  }, [orderBy])

  return {
    orderByChange,
    orderBy,
    orderDirection,
    sort,
  }
}

export default useSort